import intl from 'react-intl-universal';
import { isGlobalEnv } from '@/config';
import type { AfterSalesTypes } from '@/type/common';

// 1-换货 2-退款 3-退货退款 4-维修 5-补券 6-补发配件
// type: "售后类型_子类型_订单渠道_原因类型(运费退款子类型为1，机器人退款订单渠道:12)",
//原因类型:1-售后原因(包括退款原因) 2-瑕疵原因 3-瑕疵部位
export const ReasonMap = {
    '1_0_0_1': 'exSalesReason',
    '1_0_0_3': 'exSalesFlawPositon',
    '2_0_0_1': 'refundReason',
    '2_0_12_1': 'refundRobotReason',
    '2_1_0_1': 'refundFareReason',
    '2_0_0_2': 'refundFlawReason',
    '2_0_0_3': 'refundFlawPosition',
    '4_0_0_1': 'repairReason',
    '4_0_0_3': 'repairFlawPosition',
    '5_0_0_1': 'couponReason',
    '5_0_0_2': 'couponFlawReason',
    '5_0_0_3': 'couponFlawPosition',
    '6_0_0_1': 'accessoryReason',
};

export const OTHERVALUE = 9999;

export const AftersaleType: { [key in AfterSalesTypes]: number } = {
    ReSales: 3,
    ReMoney: 2,
    ExSales: 1,
    Maintain: 4,
    Coupon: 5,
    Accessory: 6,
    ReCharges: 7,
    ReSend: 6,
    ReBuild: 9,
    ReBuild1: 9,
    RobotSend: 11,
};

// 以下一级瑕疵原因 附件必填
export const FileRequiredAftersaleReason = {
    [AftersaleType.ReSales]: [1000, 2000, 3000, 4000, 5000, 6000, 12000],
    [AftersaleType.ExSales]: [1000, 2000, 3000, 4000, 5000, 6000],
    [AftersaleType.Coupon]: [1000, 2000],
    [AftersaleType.Maintain]: [1000, 2000, 3000, 4000, 5000, 6000],
    // 机器人渠道
    Robot: [1000, 2000, 3000, 5000, 6000],
};

// 1-换货 2-仅退款 3-退货退款 4-维修 5-补券 6-补发配件  22-机器人退款 23-机器人仅退款 11-商品邮寄
export const AftersaleReasonsConfigs: () => {
    [key: string]: {
        aftersaleName: string;
        fieldName: string;
        supportKey: string;
        disable: boolean; // 是否可编辑
    };
} = () => {
    return isGlobalEnv
        ? {
              1: {
                  aftersaleName: intl.get('换货'),
                  fieldName: 'ExSales',
                  supportKey: 'support_swap',
              },
              9: {
                  aftersaleName: intl.get('补发积木'),
                  fieldName: 'ReBuild',
                  supportKey: 'support_building_block_part',
                  disable: false,
              },
          }
        : {
              1: {
                  aftersaleName: intl.get('换货'),
                  fieldName: 'ExSales',
                  supportKey: 'support_swap',
              },
              2: {
                  aftersaleName: intl.get('仅退款'),
                  fieldName: 'ReMoney',
                  supportKey: 'support_only_refund',
              },
              3: {
                  aftersaleName: intl.get('退货退款'),
                  fieldName: 'ReSales',
                  supportKey: 'support_refund',
              },
              4: {
                  aftersaleName: intl.get('维修'),
                  fieldName: 'Maintain',
                  supportKey: 'support_repair',
              },
              5: {
                  aftersaleName: intl.get('补券'),
                  fieldName: 'Coupon',
                  supportKey: 'support_coupon',
              },
              6: {
                  aftersaleName: intl.get('补发配件'),
                  fieldName: 'Accessory',
                  supportKey: 'support_accessory',
              },
              // 7: {
              //     aftersaleName: '补发商品',
              //     fieldName: 'ReCharges',
              // },
              9: {
                  aftersaleName: '积木补件',
                  fieldName: 'ReBuild',
                  supportKey: 'support_resend_part',
              },

              22: {
                  aftersaleName: intl.get('机器人退款'),
                  fieldName: 'RobotReSale',
                  supportKey: 'support_robot_refund',
                  disable: true,
              },
              23: {
                  aftersaleName: intl.get('机器人仅退款'),
                  fieldName: 'RobotReMoney',
                  supportKey: 'support_robot_only_refund',
                  disable: true,
              },
              11: {
                  aftersaleName: intl.get('商品邮寄'),
                  fieldName: 'RobotReMoney',
                  supportKey: 'support_robot_resend_port',
              },
          };
};
